import GamesListContainer from './games_list_container';

export default GamesListContainer;
